
var sprite = require("/Users/guten/dev/src/react/antd-mobile/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"cross\" > <defs/> <g id=\"cross_ALL-ICON\" stroke-rule=\"evenodd\" stroke-width=\"1\" fill-rule=\"evenodd\"> <g id=\"cross_Group-15\" fill-rule=\"evenodd\" transform=\"translate(6.000000, 6.000000)\"> <rect id=\"cross_Rectangle-1643\" opacity=\"0\" x=\"0\" y=\"0\" width=\"22\" height=\"22\"/> <path d=\"M18.0084687,15.8522394 L26.9766601,6.8840479 L25.0926122,5 L16.1244208,13.9681915 L7.15622933,5 L5.27218143,6.8840479 L14.2403729,15.8522394 L5,25.0926122 L6.8840479,26.9766601 L16.1244208,17.7362872 L25.3647937,26.9766601 L27.2488416,25.0926122 L18.0084687,15.8522394 Z\" id=\"cross_Combined-Shape\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "cross");


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/assets/cross.svg
 ** module id = 446
 ** module chunks = 0
 **/